import { render, staticRenderFns } from "./TaxCheck.vue?vue&type=template&id=f938b9e2"
import script from "./TaxCheck.vue?vue&type=script&lang=js"
export * from "./TaxCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports